module.exports = __webpack_public_path__ + "media/assets/images/github_icon-ccc9e19951ebe81346883f03aa788d12.png";